// extracted by mini-css-extract-plugin
export default {"wrapper":"Lp-z","response":"Mp-z","error":"Np-z","disabled":"Op-z","buttons":"Pp-z","feedbackQuestionSection":"Qp-z","yesNoWrapper":"Rp-z"};